module.exports = __webpack_public_path__ + "img/learningpath_certificate_logo.d1122a36.svg";